import React from 'react';
import { Calendar } from 'lucide-react';

const presets = [
  { label: 'This Week', getValue: () => {
    const now = new Date();
    const day = now.getDay();
    const start = new Date(now);
    start.setDate(now.getDate() - day);
    return { start_date: fmt(start), end_date: fmt(now) };
  }},
  { label: 'This Month', getValue: () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    return { start_date: fmt(start), end_date: fmt(now) };
  }},
  { label: 'Last Month', getValue: () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const end = new Date(now.getFullYear(), now.getMonth(), 0);
    return { start_date: fmt(start), end_date: fmt(end) };
  }},
  { label: 'This Quarter', getValue: () => {
    const now = new Date();
    const qMonth = Math.floor(now.getMonth() / 3) * 3;
    const start = new Date(now.getFullYear(), qMonth, 1);
    return { start_date: fmt(start), end_date: fmt(now) };
  }},
  { label: 'This Year', getValue: () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 1);
    return { start_date: fmt(start), end_date: fmt(now) };
  }},
  { label: 'All Time', getValue: () => ({ start_date: '', end_date: '' }) },
];

function fmt(d) {
  return d.toISOString().split('T')[0];
}

const DateRangeFilter = ({ startDate, endDate, onChange }) => {
  const handlePreset = (preset) => {
    const { start_date, end_date } = preset.getValue();
    onChange({ start_date, end_date });
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Calendar className="h-4 w-4 text-gray-400" />
      <input
        type="date"
        value={startDate || ''}
        onChange={(e) => onChange({ start_date: e.target.value, end_date: endDate })}
        className="px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-yellow-500 focus:border-yellow-500"
      />
      <span className="text-gray-400 text-sm">to</span>
      <input
        type="date"
        value={endDate || ''}
        onChange={(e) => onChange({ start_date: startDate, end_date: e.target.value })}
        className="px-2 py-1 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-yellow-500 focus:border-yellow-500"
      />
      <div className="flex gap-1 ml-2">
        {presets.map((p) => (
          <button
            key={p.label}
            onClick={() => handlePreset(p)}
            className="px-2 py-1 text-xs rounded bg-gray-100 hover:bg-yellow-100 text-gray-600 hover:text-yellow-800 transition-colors"
          >
            {p.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DateRangeFilter;
